import { DpadKeyCode, DpadZoneType, ExcreationSortType, OfficeType } from "@core/constants";
import { CheckSheetDisplayOrder, DataType, FieldActivityType, InputType, SearchType} from "../enums";
import { BathDais } from "./bathe.model";

/* **********************************************************************************************************************
   **********************************************************************************************************************         
                                  ░██████╗░███████╗███╗░░██╗███████╗██████╗░░█████╗░██╗░░░░░
                                  ██╔════╝░██╔════╝████╗░██║██╔════╝██╔══██╗██╔══██╗██║░░░░░
                                  ██║░░██╗░█████╗░░██╔██╗██║█████╗░░██████╔╝███████║██║░░░░░
                                  ██║░░╚██╗██╔══╝░░██║╚████║██╔══╝░░██╔══██╗██╔══██║██║░░░░░
                                  ╚██████╔╝███████╗██║░╚███║███████╗██║░░██║██║░░██║███████╗
                                  ░╚═════╝░╚══════╝╚═╝░░╚══╝╚══════╝╚═╝░░╚═╝╚═╝░░╚═╝╚══════╝
 ************************************************************************************************************************
 ************************************************************************************************************************ */

export class DialogTemplate {
    isShowHeader: boolean = true;
    header: string = "";
    isDismissableMask: boolean = false;
    isModal: boolean = true;
    breakpoints?: any = {};
    style: any = {};
    hasBottom: boolean = true;
    isResizable: boolean = false;
    closable: boolean = true;
    appendTo: string = '';
    styleClass: string = '';
    closeOnEscape: boolean = true;
    hasFooter?: boolean = false;
}


export class Menu {
    id?: string;
    name?: string;
    subName?: string;
    title?: string;
    routerLink?: string;
    icon?: string;
    active?: boolean;
    display?: boolean = true;
}

export class UserInfoModel {
    daicd?: string;
    blobImg!: string;
    family!: string;
    given!: string;
    kanafamily!:string;
    kanagiven!:string;
    romanjiFamily?: string;
    romanjiGiven?: string;

    // sex 1 is male, 0 is female
    sex: 0 | 1 = 0;
    face_img!: string;
    isWarning: boolean = false;
    cssStyle?: UserStyleModel;
    isHighlightRecord?: boolean = true;
}

  
export class UserStyleModel {
    width!: string;
    height!: string;
}

export class LabelModel {
    width?: string;
    height?: string;
}
export class FieldActivityLogModel {
     // độ rộng của timeline
  width?: string = '100%';
  // chiều cao của timeline
  height?: string = '100px';
  // giá trị giờ nhỏ nhất
  min!: number;
  // giá trị giờ lớn nhất
  max!: number;
  // render Activitylog theo giờ hiện tại hoặc theo max min
  isRenderActivityLogByMaxMin?: boolean = false;
  // chiều cao của mỗi item.
  itemHeight: string = 'auto';
  // Số hàng trong grid mặc định là 1
  rows?: number = 2;
  // biên độ (số giờ giữa các mốc)
  interval: number = 2;
  // cài đặt bước nhảy thời gian mặc định là 30p tuỳ setup
  timeInterval: number = 30;
  // ẩn border
  isHiddenBorder?: boolean = false;
  // ẩn header
  isHiddenHeader?: boolean = true;
  // ẩn highlight
  isHiddenHighLight?: boolean = true;
  // số phân đoạn thời gian
  segmentNum: number = 4;
  // sắp xếp tăng dần nếu isAsc = true ngược lại sắp xếp giảm dần
  isAsc: boolean = true;
  // padding
  padding: string = '';
  // style theo format 24h
  is24HourFormat?: boolean = false;
  // type bằng 1 time chạy theo khoảng min-max, type = 2 chạy theo giờ hiện tại line đỏ chạy từ trái qua phải
  // type = 3 chạy theo giờ hiện tại line đỏ đứng im nội dung bên dưới chạy từ phải qua trái
  type: number = 1; // 1 | 2 | 3
  // căn lề phải so với giờ hiện tại
  marginToTime?: number = 45;
  // hiển thị theo ngày
  recentDates: string[] = [];
  isShowTimePointer: boolean = true;
  separateDays: boolean = false;
}

export class FieldActivityLogItemModel {
    blinking?: boolean;
    type!: FieldActivityType;
    time!: string;
    volume!: string;
    attention_flg?: boolean;
    screen: string = '';
}
export class GridGroupDataModel {
    groupName: string = '';
    items: any[] = [];
}

export class HeaderItemModel {
    field: string = '';
    title: string = '';
    dataType: DataType = DataType.TEXT;
    visible: boolean = true;
    width?: string = 'auto';
    textAlign:string = 'center';
}
export class VitalModel {
    temperature: number = 0;
    bp_top: number = 0;
    bp_bottom: number = 0;
    pulse: number = 0;
    spo2: number = 0;
    attention_flg: boolean = false;
    date?: string;
}

export class AttentionInfoModel {
    status_kbn: number = 0;
    attention_flg: boolean = false;
}

export class MealModel {
    main: number = 0;
    sub: number = 0;
    attention_flg: boolean = false;
}

export class DialogTemplateModel {
    isShowHeader: boolean = true;
    header: string = "";
    //If false => prevent hidding the dialog when click the modal background;
    isDismissableMask: boolean = false; 
    isModal: boolean = true;
    breakpoints?: any = {};
    style: any = {};
    hasBottom: boolean = true;
    isResizable: boolean = false;
    closable: boolean = true;
    appendTo: string = '';
    styleClass: string = '';
    closeOnEscape: boolean = true;
    hasFooter?: boolean = false;
}

export class InputParams {
    readonly: boolean = false; // readOnly input status
    disabled: boolean = false; // disable input status
    validate?: boolean = false; // check validate for input
    validateError?: string = ''; // validate error string 
    placeholder?: string = '';  // input place holder
    type: InputType = InputType.text; // input type
    inputStyle?: any = null; // input style css
    borderFill?: boolean = true; // set border fill for input
    borderRed?: boolean = false;
    isValidate?: boolean = false;
    isError?: boolean = false;
    maxLength?: number;
    minLength?: number;
    hidden?: boolean = false;
    tabindex?: number = 1;
}

export class SearchParams {
    type: SearchType = SearchType.input;
    placeholder?: string = '';
    cssStyle: any = {};
    readonly: boolean = false;
    disabled: boolean = false;
    dataSource?: any[] = [];
    comboDisplayText?: string = '';
    defaultValue?: string = '';
    selected?: any;
    isFilter?: boolean = true;
    maxLength?: number | null = null;
    objectData?: any = {}; 
    borderRed?: boolean = false;
    selfReset?: boolean = false; // If true, search textbox will be reset when re-open
}

export class FilterItem {
    id: string = '';
    name: string = '';
    checked: boolean = false;
    isLabel: boolean = false;
    parent: string = '';
    level?: string;
}
export class RadioItem {
    key: string = '';
    label: string = '';
}

export class RadioOutputItem {
    data: RadioItem = new RadioItem();
    value: boolean = false;
}

export class ConfirmDialogModel {
    display?: boolean = false;
    message!: string;
    header!: string;
}

export class TimeElapsedModel {
    id?: string = '';
    comparition?: string = 'like';
    matchValue?: string = '';
    count?: number = 1;
}
export class TextMarqueeModel {
  type: string = '';
  message: string = '';
}
export class TextMarqueeConfig {
    width: string = '100%';
    height: string = '100%';
    highlight: boolean = false;
    minWidth: string = '-webkit-fill-available';
}

export class DynamicLabelModel {
    iconPath: string = '';
    labelValue?: string = '';
    labelPosition: 'center' | 'top' | 'bottom' | 'left' | 'right' | 'onIcon' = 'top';
    borderStyle: 'none' | 'solid' | 'dashed' | 'dotted' = 'none';
    borderWidth: string = '1px'; 
    borderRadius: string = '0px';
    fontSize: string = '14px';
    minWidth: string = 'max-content';
    minHeight: string = 'auto';
    iconWidth: string = '24px';
    iconHeight: string = '24px';
    highlight: boolean = false;
    whitespace: 'normal' | 'nowrap' = 'nowrap';
}

export class BatsuMaruConfigModel {
    fontSize?: string;
    highlight: boolean = false;
}

export class YesNoIndicatorConfigModel {
    fontSize?: string;
    highlight: boolean = false;
    officeType: number = OfficeType.notSupport;
}

export class NyuShoDisplayConfigModel {
    isSortByRoom: boolean = true;
    isSortByName: boolean = false;
    timeRangeSelected: number = 6;
    marginToTimeSelected: number = 30;
    unitSelected: any = [];
    groupSelected: any = [];
}

export class ExcreationConfigModel {
    sortType: ExcreationSortType = ExcreationSortType.BY_EXCREATION_TIME;
}

export class SettingConfigModel {
    time_grouping_flg: boolean = false;
    sorting_time: CheckSheetDisplayOrder.StartTime | CheckSheetDisplayOrder.EndTime = CheckSheetDisplayOrder.StartTime;
    display_order: CheckSheetDisplayOrder = CheckSheetDisplayOrder.StartTime;
    hidden_overtime_flg: boolean = false;
    hidden_leave_user: boolean = false;
}

export class GridHeaderModel {
    width: string = 'auto';
    items?: any[] = [];
    // header hiển thị nhiều mục
    isSplitCell?: boolean = false;
    // list subheader
    subheader?: any[] = [];
    headeRepeat?: number = 1;
    // cố định size và không thay đổi kích thước khi ẩn/ hiện cột
    fixedSize?: boolean;
}

export class GridHeaderItemModel {
    width: string = 'auto';
    items?: any[] = [];
    // header hiển thị nhiều mục
    isSplitCell?: boolean = false;
    // list subheader
    subheader?: any[] = [];
    headeRepeat?: number = 1;
    field!: string;
    config!: any;
    component: string = '';
    columnspan: number = 1;
}

export class GridConfigModel {
    // có group hay không
    isGroupData?: boolean = false;
    // trang hiện tại
    currentPage: number = 1;
    // tổng số trang
    totalPage: number = 1;
    // số lượng item trên 1 page
    pageSize: number = 10;
    // tự động chuyển page
    isLockPage: boolean = false;
    headerTextColor?: string = 'white';
    headerBorder?: string = 'none';
    headerBackgroundColor?: string = 'none';
    intervalTime: number = 30000;
}

export class PageSettingModel {
    currentPage: number = 1;
    totalPage: number = 1;
}
export class DropdownOption {
    name: string = "";
    value: string = "";

    constructor(nameVal: string, valueVal: string) {
        this.name = nameVal;
        this.value = valueVal;
    }
}

export class conditionItemModel {
    id: string = "";
    field: string = "";
    comparison: string = "";
    val: string = "";
    dockbn: string = "";
    ttlkbn: string = "";
    ttlcd: string = "";
    itemid: string = "";
    notekbn: string = "";
    wtype: string = ""
    im: number = 0;
    itemname: string = "";
    childids?: string = "";
    tag?:string="";
}

export class LazyTreeNode {
    id?: string = "";
    text?: string = "";
    level?: number = 0;
    parent?: LazyTreeNode;
    tooltip?: string = '';
    expanded: boolean = false;
    expandable?: boolean = false;
    node?: any;
    isFirstNode?: boolean = false;
    isLastNode?: boolean = false;
    showIcon?: boolean = false;
    draggable?: boolean = false;
    style?:  any = {};
    icon?: string = "";
    isFolder?: boolean;
    treeData?: TreeViewInputParams;
    lazyData?: LazyTreeNode[];
    isLastChild?: boolean = false;
    isParentLastChild?:boolean[] = [];
    selected: boolean = false;
    loading:boolean = false;
    isShowNoData: boolean = false;
}

export class BathTreeNode {
    label?: string = "";
    code?:string = "";
    type?: 'office' | 'block' | 'unit' | 'bathroom';
    isOpen?: boolean = false;
    children?: BathTreeNode[] = [];
}

export class BathRoom extends BathTreeNode {
    daiList?: string[] = [];
    corpCd?: string = "";
    officeCd?: string = "";
    blockCd?: string = "";
    subCd?: string | null = null;
    unitCd?: string = "";
    bathRoomCd?: string = "";
    bathName?: string = "";
    capacity?: number;
    sortNo?: number | null = null;
    bathRule?: string | null = null;
    settingSource?: BathDais[] = [];

    // DynamoDB keys (for new API)
    partitionKey?: string = "";
    sortKey?: string = "";
    insDate?: string = "";
    insStfCd?: string = "";
    /** Audit stamp this room was loaded at, for display only. */
    updDate?: string;
    /** ITEMVER this room was loaded at, sent back on save/delete to detect a stale edit. */
    itemVer?: number | null;
    constructor(init?: Partial<BathRoom>) {
        super();
        Object.assign(this, init);
    }
}

export class TreeNode {
    id?: string;
    labelId? : string;
    nodes?: TreeNode[];
    icon?: string;
    label?: string;
    selected?: boolean = false;
    expanded?: boolean = false;
    parent?: TreeNode;
    isShowCheckBox?: boolean = true;
    draggable?: boolean = false;
    isShowExpandIcon?: boolean = false;
    isShowIcon?: boolean = true;
    isLastNode?: boolean = false;
    name?: string;
    type?: string;
    data?: any[] = [];
    tooltip?: any[] = [];
    hidden? = false;
    singleSelected?: boolean = false;
    canDelete?: boolean = false;
    hasAction?: boolean = false;
    style?: any = {};
    visible?:boolean = false;
    highlighted?: boolean = false;
    childinfarray?: []; 
    parentInf?: string;
    isLoaded?: boolean = false;
    isSpin?: boolean = false;
}

export class TreeViewInputParams {
    nodes: TreeNode[] = [];
    dragScope?: string = '';
    checkbox?: boolean; // enable checkbox tree mode
    expanded?: boolean; //Expand all at start
    allowParentSelect?: boolean = true;
    expandIcon?: string = '';
    collapseIcon?: string = '';
    selectable?: boolean;
    hoverable?: boolean = false;
    isDisplayTooltip?: boolean = false;
    isMultiDragItem?: boolean = false;
}

export class MasterTitle {
    id?: string = "";
    officecd?: string;
    blockcd? : string;
    unitcd?: string;
    ttlkbn?: string;
    ttlcd?: string;
    itemid?: string;
    displayname?: string;
    columntype: number = 0;
    sdate?: string;
    edate?: string;
    sortno: number = 0;
    datatype?: string;
    notekbn?: number = 0;
    dockbn?: boolean;
    delflg: boolean = false;
    tooltip?: string;
    tabtype?: number;
    wtype?: number;
    im?: number;
  }

/* **********************************************************************************************************************
   **********************************************************************************************************************
                                          ██████╗░██████╗░░█████╗░██████╗░
                                          ██╔══██╗██╔══██╗██╔══██╗██╔══██╗
                                          ██║░░██║██████╔╝███████║██║░░██║
                                          ██║░░██║██╔═══╝░██╔══██║██║░░██║
                                          ██████╔╝██║░░░░░██║░░██║██████╔╝
                                          ╚═════╝░╚═╝░░░░░╚═╝░░╚═╝╚═════╝░
************************************************************************************************************************
************************************************************************************************************************ */

export class ParmaGetNextZone {
    dpadDirection?: string
    currentZoneType?: number;
    configDpadZoneHeader?: any;
    configDpadZoneSubHeader?: any;
    configDpadZoneMenu?: any;
    configDpadZoneScreen?: any;
    configDpadZoneLogin?: any;
    configDpadZoneTvLayout?: any;
    configDpadZoneTvOfficeSelect?: any;
    configDpadZoneTvUserSettingsMid?: any;
    configDpadZoneTvUserSettingsRight?: any;
    configDpadZoneTvCorpLogin?: any;
    configDpadZoneUserDashBoard?: any;
    configDpadZoneMain?: any;
}
export interface DpadZone {
    dType: DpadZoneType,
    dXMin: DpadZoneType,
    dXMax: DpadZoneType,
    dYMin: DpadZoneType,
    dYMax: DpadZoneType,
}
export interface DpadZoneState {
    dZone: any,
    dX: number,
    dY: number,
    dKey: DpadKeyCode
}
export interface DpadPositonState {
  zone: number,
  x: number,
  y: number,
  keyCode: DpadKeyCode
}
